// Zentrale Liste aller Frontend-Seiten – Quelle für den Sync ins CMS
export type FrontendPage = {
  path: string;
  slug: string;
  title: string;
  description?: string;
  is_dynamic?: boolean;
  sort_order?: number;
};

export const FRONTEND_PAGES: FrontendPage[] = [
  { path: "/", slug: "home", title: "Startseite", sort_order: 0 },
  { path: "/suites", slug: "suites", title: "Suiten – Übersicht", sort_order: 10 },
  { path: "/suites/:slug", slug: "suite-detail", title: "Suite – Detail", is_dynamic: true, sort_order: 11 },
  { path: "/lerch-plus", slug: "lerch-plus", title: "Lerch Plus", sort_order: 20 },
  { path: "/wellness", slug: "wellness", title: "Wellness", sort_order: 30 },
  { path: "/erlebnisse", slug: "erlebnisse", title: "Erlebnisse – Übersicht", sort_order: 40 },
  { path: "/erlebnisse/sommer", slug: "erlebnisse-sommer", title: "Erlebnisse – Sommer", sort_order: 41 },
  { path: "/erlebnisse/winter", slug: "erlebnisse-winter", title: "Erlebnisse – Winter", sort_order: 42 },
  { path: "/erlebnisse/top-events", slug: "erlebnisse-top-events", title: "Erlebnisse – Top Events", sort_order: 43 },
  { path: "/bewertungen", slug: "bewertungen", title: "Bewertungen", sort_order: 50 },
  { path: "/buchen", slug: "buchen", title: "Buchen", sort_order: 60 },
  { path: "/anfrage", slug: "anfrage", title: "Anfrage", sort_order: 61 },
  { path: "/lage-anreise", slug: "lage-anreise", title: "Lage & Anreise", sort_order: 70 },
  { path: "/sitemap", slug: "sitemap", title: "Sitemap", sort_order: 90 },
  { path: "/impressum", slug: "impressum", title: "Impressum", sort_order: 100 },
  { path: "/datenschutz", slug: "datenschutz", title: "Datenschutz", sort_order: 101 },
  { path: "/barrierefreiheit", slug: "barrierefreiheit", title: "Barrierefreiheit", sort_order: 102 },
  { path: "/:slug", slug: "dynamic", title: "Dynamische WordPress-Seite", is_dynamic: true, sort_order: 200 },
];
